export default function suggestionUrl(columnType, domainType) {
	return `api/reports/suggestions?columnType=${columnType}&domainType=${domainType}`
}
